import { nativeEvents } from '@rocketlane/rocket-llm';
export const convertPolicyResponseToSection = (policy, violationId)=>{
    const result = policy.reduce((acc, item)=>{
        var _ref;
        var _item_rules;
        if (!item.isViolated) {
            return acc;
        }
        const children = (_ref = (_item_rules = item.rules) === null || _item_rules === void 0 ? void 0 : _item_rules.filter((rule)=>rule.isViolated)) !== null && _ref !== void 0 ? _ref : [];
        if (children.length > 0) {
            acc.push({
                ...item,
                rules: children
            });
        }
        return acc;
    }, []);
    return {
        policy: result,
        violationId
    };
};
/**
 * Handles 422 policy conflict errors by showing the policy conflict modal.
 * Extracts projectId, ruleResults, and violationId from the error response.
 * Also captures the original request config so the request can be retried
 * after the user resolves the conflicts.
 *
 * This is used in the global axios interceptor to handle policy conflicts for all API calls.
 *
 * @param err - The error object from API response
 */ export const handlePolicyConflictError = (err)=>{
    var _ref;
    var _error_response;
    const error = err;
    const data = (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data;
    if (!data || typeof data !== 'object') {
        return;
    }
    const d = data;
    const { ruleResults, executionId, projectId: rawProjectId } = d;
    if (!Array.isArray(ruleResults) || ruleResults.length === 0) {
        return;
    }
    if (rawProjectId == null) {
        return;
    }
    const projectId = typeof rawProjectId === 'number' ? rawProjectId : Number.parseInt(String(rawProjectId), 10);
    if (!Number.isFinite(projectId)) {
        return;
    }
    const originalRequestConfig = (_ref = err === null || err === void 0 ? void 0 : err.config) !== null && _ref !== void 0 ? _ref : null;
    nativeEvents.publish('policyConflictModel', {
        show: true,
        policy: convertPolicyResponseToSection(ruleResults, executionId !== null && executionId !== void 0 ? executionId : 0),
        projectId,
        executionId,
        errorData: d,
        originalRequestConfig
    });
};
